import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

import { IonSegment, IonSegmentButton, IonLabel } from '@ionic/vue'
import { TDeliveryDocumentType } from '@/const/types/documents';
import { deliveryTypes } from '@/const/documentTypes'

interface Props {
    modelValue: null | TDeliveryDocumentType;
    disabled: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliveryTypeSelect',
  props: {
    modelValue: null,
    disabled: { type: Boolean }
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as {
    modelValue: null | TDeliveryDocumentType;
    disabled: boolean;
};






return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonSegment), {
    value: props.modelValue,
    disabled: props.disabled,
    onIonChange: _cache[0] || (_cache[0] = $event => emit('update:modelValue', $event.target.value))
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deliveryTypes), (type) => {
        return (_openBlock(), _createBlock(_unref(IonSegmentButton), {
          key: type,
          value: type
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(type), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["value", "disabled"]))
}
}

})